import React from 'react'
import { useParams } from 'react-router-dom'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { StudentTopMenuLayout } from '../../Layout/StudentTopMenu/StudentTopMenuLayout'
import { CollegeList911 } from './CollegeList911'

const StudentCollegeList911 = () => {
	const { studentId } = useParams()
	const { user } = useAuth()
	const isInstructorView = user?.role === 'Instructor'
	const effectiveStudentId = isInstructorView ? studentId : user?.id

	return (
		<StudentTopMenuLayout activeMenu="CollegeList911" pageName="CollegeList911">
			<CollegeList911 studentId={effectiveStudentId} />
		</StudentTopMenuLayout>
	)
}

export { StudentCollegeList911 }
